// extracted by mini-css-extract-plugin
export const pageTitle = "terms-module--pageTitle--31aFN";
export const termsContent = "terms-module--termsContent--3f_T_";
export const articleTitle = "terms-module--articleTitle--1xCnV";
export const articleContent = "terms-module--articleContent--2MXLy";
export const backButton = "terms-module--backButton--1F8Fk";
export const mobileTitle = "terms-module--mobileTitle--1zkQq";
export const pageWrapper = "terms-module--pageWrapper--6Lpbv";
export const burgerPosition = "terms-module--burgerPosition--2waTF";